
import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          textAlign: 'center',
        }}
      >
        <Typography variant="h1" component="h1" gutterBottom fontWeight="bold">
          {t('pages.notFound.title')}
        </Typography>
        <Typography variant="h5" component="h2" gutterBottom>
          {t('pages.notFound.subtitle')}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {t('pages.notFound.description')}
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={() => navigate('/')}
          sx={{ mt: 2 }}
        >
          {t('pages.notFound.returnButton')}
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;
